module.exports = __webpack_public_path__ + "21cc10b5508b9669d9194dedde56eb45.svg";